import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface CreateAIPlanBlueprintState {
  companyName: string
  companyDomain: string
  employees?: number
  revenue?: number
  positioning: string
  userProvidedInsights: string
  instantPlanEnabled: boolean
}

const initialState: CreateAIPlanBlueprintState = {
  companyName: '',
  companyDomain: '',
  employees: undefined,
  revenue: undefined,
  positioning: '',
  userProvidedInsights: '',
  instantPlanEnabled: false
}

const createAIPlanBlueprintSlice = createSlice({
  name: 'createAIPlanBlueprint',
  initialState,
  reducers: {
    setCompanyName(state: CreateAIPlanBlueprintState, { payload }: PayloadAction<string>) {
      state.companyName = payload
    },
    setCompanyDomain(state: CreateAIPlanBlueprintState, { payload }: PayloadAction<string>) {
      state.companyDomain = payload
    },
    setEmployees(state: CreateAIPlanBlueprintState, { payload }: PayloadAction<number | undefined>) {
      state.employees = payload
    },
    setRevenue(state: CreateAIPlanBlueprintState, { payload }: PayloadAction<number | undefined>) {
      state.revenue = payload
    },
    setPositioning(state: CreateAIPlanBlueprintState, { payload }: PayloadAction<string>) {
      state.positioning = payload
    },
    setUserProvidedInsights(state: CreateAIPlanBlueprintState, { payload }: PayloadAction<string>) {
      state.userProvidedInsights = payload
    },
    setInstantPlanEnabled(state: CreateAIPlanBlueprintState, { payload }: PayloadAction<boolean>) {
      state.instantPlanEnabled = payload
    },
    reset(state: CreateAIPlanBlueprintState) {
      Object.assign(state, initialState)
    }
  }
})

export const { setCompanyName, setCompanyDomain, setEmployees, setRevenue, setPositioning, setUserProvidedInsights, setInstantPlanEnabled, reset } = createAIPlanBlueprintSlice.actions

export default createAIPlanBlueprintSlice.reducer
